import './styles.scss'
import { Data } from './controller'
import ons from 'onsenui'
import panzoom from 'panzoom'
import ShareMenu from '../share-menu'
import Mousetrap from 'mousetrap'
import _ from 'lodash'


var Carousel = function() {
  let zoomers = []
  const startZoom = (el=document) => {
    const items = [...el.querySelectorAll('.pz')]
    zoomers = items.map(item => panzoom(item, {
      maxZoom: 10,
      minZoom: 1,
      bounds: true,
      boundsPadding: 1
    }))
  }
  const stopZoom = () => {
    zoomers.forEach(inst => {
      inst.zoomAbs(0, 0, 1)
      setTimeout(() => inst.dispose(), 100)
    })
    zoomers = []
  }
  // document.addEventListener('pinch', e => startZoom())
  // document.addEventListener('doubletap', e => startZoom())
  return {
    onbeforeupdate: (vnode, old) => {
      // extremely baffling: must remove extra nodes manually...
      const item = old.dom.querySelector('ons-carousel-item')
      if(!item) return
      const parent = item.parentElement
      let extraNodes = parent.children.length - vnode.attrs.charts.length
      while(extraNodes > 0) {
        extraNodes -= 1
        parent.removeChild(parent.lastElementChild)
      }
      if(vnode.attrs.zoom) {
        startZoom(old.dom)
      } else {
        stopZoom()
      }
    },
    onbeforeremove: (vnode) => {
      stopZoom()
    },
    view: (vnode) => {
      const { charts } = vnode.attrs
      return m("ons-carousel.chart-carousel[fullscreen][swipeable][auto-scroll][auto-scroll-ratio=0.15][auto-refresh]",
        charts.map(chart => {
          return m("ons-carousel-item.item",
            m('.pz', {
              style: {"background-image":`url(${chart.src})`}
            })
          )
        })
      )
    }
  }
}

let parseUrl = href => {
  let parser = document.createElement('a')
  parser.href = href
  return parser
}




const linkMap = {}
const linkShortener = async (share) => {
  if(share && share.url) {
    if(!linkMap[share.url]) {
      const resp = await m.request({
        method: "GET",
        url: "/shortlink",
        params: share,
        background: true
      })
      linkMap[share.url] = resp.shortLink
    }
    share.url = linkMap[share.url]
  }
}


var Charts = function() {
  let share = {}
  let geo
  let hotkeysBound

  const setShare = attrs => async evt => {
    const charts = _.get(Data, 'charts.result.charts')
    if(charts && charts.length) {
      const chart = charts[evt.activeIndex]
      const charturl = parseUrl(chart.src)
      const url = parseUrl('/share/graph')

      const title = chart.title || (geo ? `${encodeURIComponent(geo)}'s coronavirus graph` : 'CoronaPulse')
      const image = encodeURIComponent(charturl.pathname)
      const description = encodeURIComponent(chart.desc)

      url.search = `title=${title}&image=${image}&description=${description}`
      url.protocol = 'https:'
      share.url = url.href.replace(url.host, 'coronapulse.net')
      share.text = chart.desc ? chart.desc + ' #CoronaPulse' : '#CoronaPulse'
      await linkShortener(share)
    }
  }

  return {
    oninit: async (vnode) => {
      const charts = await Data.charts.fetch(vnode.attrs)
    },
    onbeforeupdate: (vnode, old) => {
      if(vnode.attrs.chart !== old.attrs.chart) {
        Data.charts.fetch(vnode.attrs)
          .then(data => {
            Object.assign(vnode.attrs, data)
            m.redraw()
          })
      }
    },
    onupdate: (vnode) => {
      const carousel = document.querySelector('ons-carousel')
      if(vnode.attrs.geo) {
        geo = vnode.attrs.geo
      }
      if (carousel) {
        try {
          setShare(vnode.attrs)({ activeIndex: carousel.getActiveIndex() })
        } catch (e) {}
        if(!carousel.watching) {
          carousel.addEventListener('postchange', setShare(vnode.attrs))
          carousel.watching = true
        }
        if(!hotkeysBound) {
          Mousetrap.bind('left', () => carousel.prev())
          Mousetrap.bind('right', () => carousel.next())
          hotkeysBound = true
        }
      }
    },
    view: (vnode) => {
      if(Data.charts.result) {
        return [
          m(Carousel, { ...vnode.attrs, ...Data.charts.result }),
          !vnode.attrs.zoom &&
          m(ShareMenu, { share })
        ]
      }
    }
  }
}


export default Charts
